import { ShowHide } from 'components/layout';
import { Breadcrumbs, HorizontalLinkGroup } from 'components/navigation';
import { UserHasAccess } from 'components/user-access';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const viewAction = "EmployeeReview:View";
const manageAction = "EmployeeReview:Manage";

export function Layout(
    {
        breadcrumbs = null,
        actionButton = null,
        children = null
    }
) {
    // The hub tabs are permission driven: the review tabs need View, the admin
    // review-types tab needs Manage, and a user can hold either without the other.
    const canViewReviews = UserHasAccess(viewAction);
    const canManageReviewTypes = UserHasAccess(manageAction);

    const tabs = [];

    if (canViewReviews) {
        tabs.push(
            { location: "/employee-reviews/overview", title: "Overview" },
            { location: "/employee-reviews/pending-reviews", title: "Pending Reviews" },
            { location: "/employee-reviews/completed-reviews", title: "Completed Reviews" }
        );
    }

    if (canManageReviewTypes) {
        tabs.push({ location: "/employee-reviews/review-types", title: "Review Types" });
    }

    return (
        <Fragment>
            <div className="row">

                <Breadcrumbs items={breadcrumbs} />

                <h1>Employee Reviews</h1>
            </div>

            <ShowHide
                evaluator={actionButton != null}
                show={(
                    <div className="row">
                        <div className="button-row spacer-bottom">
                            {actionButton}
                        </div>
                    </div>
                )}
            />

            <div className="row">
                <div className="spacer-bottom-medium">
                    <HorizontalLinkGroup links={tabs} exactRouteMatch={true}></HorizontalLinkGroup>
                </div>
            </div>

            <div className='row'>
                {children}
            </div>
        </Fragment>
    );
}

Layout.propTypes = {
    breadcrumbs: PropTypes.array,
    actionButton: PropTypes.node,
    children: PropTypes.node
};
